import { TFunction } from 'i18next';
import { v4 as uuidv4 } from 'uuid';

export const createSnackbarSuccessMessage = (
  operation: 'deleted' | 'added' | 'updated',
  enqueueSnackbar: (message: string, options: object) => void,
  name: string,
  t: TFunction
) => {
  return () => {
    const options = {
      variant: 'success',
      autoHideDuration: 3000,
      key: uuidv4(),
    };

    if (operation === 'added') {
      enqueueSnackbar(t('snackbar.success.added', { name }), options);
    } else if (operation === 'deleted') {
      enqueueSnackbar(t('snackbar.success.deleted', { name }), options);
    } else {
      enqueueSnackbar(t('snackbar.success.updated', { name }), options);
    }
  };
};

export const createSnackbarErrorMessage = (
  operation: 'delete' | 'add' | 'update',
  enqueueSnackbar: (message: string, options: object) => void,
  name: string,
  t: TFunction
) => {
  return (e: { message: string }) => {
    const options = {
      variant: 'alarm',
      autoHideDuration: 3000,
      key: uuidv4(),
    };

    if (operation === 'add') {
      enqueueSnackbar(t('snackbar.error.add', { name, message: e.message }), options);
    } else if (operation === 'delete') {
      enqueueSnackbar(t('snackbar.error.delete', { name, message: e.message }), options);
    } else {
      enqueueSnackbar(t('snackbar.error.update', { name, message: e.message }), options);
    }
  };
};
